import { useTranslation } from "react-i18next";
import {
  PageWrap,
  Section,
  Title,
  Subtitle,
  H2,
  H3,
  P,
  Ul,
  Ornament,
} from "./LegalStyles";

export default function TermsPage() {
  const { t } = useTranslation();

  const bulletsUse = t("legal.terms.use.bullets", { returnObjects: true });
  const bulletsOrders = t("legal.terms.orders.bullets", {
    returnObjects: true,
  });
  const bulletsLiability = t("legal.terms.liability.bullets", {
    returnObjects: true,
  });

  return (
    <PageWrap>
      <Ornament />
      <Section>
        <Title>{t("legal.terms.title")}</Title>
        <Subtitle>{t("legal.terms.subtitle")}</Subtitle>
      </Section>

      <Section>
        <H2>{t("legal.terms.intro.h2")}</H2>
        <P>{t("legal.terms.intro.p1")}</P>
        <P>{t("legal.terms.intro.p2")}</P>
      </Section>

      <Ornament />

      <Section>
        <H2>{t("legal.terms.use.h2")}</H2>
        <P>{t("legal.terms.use.p1")}</P>
        <Ul>
          {bulletsUse.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </Ul>
      </Section>

      <Section>
        <H2>{t("legal.terms.content.h2")}</H2>
        <P>{t("legal.terms.content.p1")}</P>
        <P>{t("legal.terms.content.p2")}</P>
      </Section>

      <Section>
        <H2>{t("legal.terms.orders.h2")}</H2>
        <P>{t("legal.terms.orders.p1")}</P>
        <Ul>
          {bulletsOrders.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </Ul>
        <P>{t("legal.terms.orders.p2")}</P>
      </Section>

      <Section>
        <H2>{t("legal.terms.payments.h2")}</H2>
        <P>{t("legal.terms.payments.p1")}</P>
      </Section>

      <Section>
        <H2>{t("legal.terms.liability.h2")}</H2>
        <P>{t("legal.terms.liability.p1")}</P>
        <Ul>
          {bulletsLiability.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </Ul>
      </Section>

      <Section>
        <H2>{t("legal.terms.law.h2")}</H2>
        <P>{t("legal.terms.law.p1")}</P>
      </Section>

      <Section>
        <H2>{t("legal.terms.contact.h2")}</H2>
        <P>{t("legal.terms.contact.p1")}</P>
      </Section>

      <Ornament />
    </PageWrap>
  );
}
